export default __webpack_public_path__ + "bml-document27550f.png";